import {isFeatureEnabled} from '@github-ui/feature-flags'

export function isCachingEnabled() {
  return isFeatureEnabled('codespaces_tab_caching')
}
